export enum UserEvent {
  event = 'event',
  loggedOut = 'loggedOut',
  loggedIn = 'loggedIn',
  customersImported = 'customersImported',
  tenantIntegrationsChanged = 'tenantIntegrationsChanged',
}

export type Nullable<T> = T | null;
export type Optional<T> = T | undefined;
export type Nullish<T> = T | null | undefined;

export type char = string;
export type Id = number;

export enum YN {
  yes = 'Y',
  no = 'N',
}

export type Timer = ReturnType<typeof setTimeout>;
export type Interval = ReturnType<typeof setInterval>;

export type DateTime = Date;

export enum PrimeSeverities {
  info = 'info',
  success = 'success',
  warn = 'warn',
  danger = 'danger',
  secondary = 'secondary',
  contrast = 'contrast',
}

export interface column {
  field?: string;
  translation: string;
  width?: string;
  class?: string;
  noSort?: boolean;
}
